import type { SelectBoxDisplayItem } from "./selectBox.types";

// Unranked items keep their relative order, after the ranked ones.
export function sortByRank(
  itemList: SelectBoxDisplayItem[],
): SelectBoxDisplayItem[] {
  return [...itemList].sort(
    (itemA, itemB) =>
      (itemA.rank ?? Number.MAX_SAFE_INTEGER) -
      (itemB.rank ?? Number.MAX_SAFE_INTEGER),
  );
}

// Unchanged items keep their reference.
export function renumberRanks(
  itemList: SelectBoxDisplayItem[],
): SelectBoxDisplayItem[] {
  return itemList.map((item, index) =>
    item.rank === index + 1 ? item : { ...item, rank: index + 1 },
  );
}

// Expects ranks contiguous from 1: ranks in between shift by one, list order is kept.
export function moveToRank(
  itemList: SelectBoxDisplayItem[],
  uuid: string,
  newRank: number,
): SelectBoxDisplayItem[] {
  const oldRank = itemList.find((item) => item.uuid === uuid)?.rank;
  const toRank = Math.min(Math.max(newRank, 1), itemList.length);

  if (oldRank === undefined || toRank === oldRank) return itemList;

  const shift = toRank < oldRank ? 1 : -1;
  const minRank = Math.min(oldRank, toRank);
  const maxRank = Math.max(oldRank, toRank);

  return itemList.map((item) => {
    if (item.uuid === uuid) return { ...item, rank: toRank };
    if (item.rank === undefined || item.rank < minRank || item.rank > maxRank) {
      return item;
    }
    return { ...item, rank: item.rank + shift };
  });
}
